import React from "react";

import { NotificationStack } from "@transfr-inc/dashboard-components";

import { useNotificationManager } from "@transfr-inc/dashboard-components/hooks";

export const NotificationContext = React.createContext({});

export default ({ children }) => {
  const {
    addNotification,
    addNotifications,
    clearNotifications,
    notifications,
    removeNotification,
  } = useNotificationManager();

  const contextValue = {
    addNotification,
    addNotifications,
    clearNotifications,
    notifications,
    removeNotification,
  };

  return (
    <NotificationContext.Provider value={contextValue}>
      {children}
      <div className="global-notification-container">
        <NotificationStack
          notifications={notifications}
          onClose={removeNotification}
          closable
          animated
        />
      </div>
    </NotificationContext.Provider>
  );
};
